export default {"src":"https://static-eshop-files.my.telia.lt/_next/static/media/favicon.d1217246.ico","height":48,"width":48,"blurWidth":0,"blurHeight":0};